/**
 * Il payload di lancio (`start_param`) che deve SOPRAVVIVERE al giro di login.
 *
 * ═══ IL DIFETTO CHE QUESTO FILE ESISTE PER CHIUDERE ═══
 * Un link `t.me/<bot>?startapp=inv_bg_<CODICE>` consegna il payload nei launch
 * params di Telegram. Ma su MOBILE l'autenticazione passa dal bridge PKCE:
 * browser esterno → `/auth/callback` → deep link `t.me/<bot>?startapp=auth_<code>`
 * → **Telegram RILANCIA la mini app**, e i launch params del rilancio portano
 * `auth_<code>`. Il payload originale non e' "in fondo alla coda": non esiste
 * piu', perche' e' stato SOSTITUITO.
 *
 * 📌 [M 06/09, bundle servito da stg-tma — la sonda usava `bg_…`, il prefisso
 * di allora: il valore resta quello MISURATO, non lo riscrivo] Un ospite non
 * autenticato che apre
 * `?startapp=bg_QK7M2NPR4T` arriva davvero fin dentro l'app — la console stampa
 * `[bridge] consume: startParam is not auth_*: bg_QK7M2NPR4T` — e l'app lo
 * SCARTA, perche' l'unico lettore di `start_param` e' il bridge di auth, che
 * accetta solo il prefisso `auth_`. L'ospite resta su `/`.
 * ⇒ Il payload arrivava e veniva buttato PRIMA ancora del login. Il login poi
 *   lo sovrascriveva. Due perdite distinte, entrambe chiuse qui.
 *
 * ═══ PERCHE' LO STASH SOPRAVVIVE ALL'INVITO (e non e' una svista) ═══
 * L'invito lato QGammon vive 15 minuti (TTL Redis). Questo stash ne vive 30.
 * La differenza e' VOLUTA: se lo stash scadesse insieme all'invito, l'ospite che
 * ci mette piu' di un quarto d'ora atterrerebbe sulla Hub senza sapere perche' —
 * cioe' esattamente il fallimento silenzioso che il deep link doveva evitare.
 * Sopravvivendo, la schermata di atterraggio puo' dire «questo invito e'
 * scaduto», che e' una risposta. Un vuoto non lo e'.
 *
 * ⚠️ Qui NON si decide nulla sull'invito: si conserva una stringa. Chi la
 * consuma (`usePendingInvite`) naviga; chi atterra (`InviteLanding`) chiede al
 * server se quel codice vale ancora. Questo file non sa se un codice sia buono,
 * e non deve saperlo.
 */

/** Chiave dello stash. Fuori da `PER_SERVICE_TOKEN_KEYS`: non e' un segreto e
 * non deve morire con la sessione — anzi, deve sopravviverle, perche' il caso
 * d'uso e' proprio «non ero loggato quando ho aperto il link». */
const PENDING_KEY = 'qlash.pending_start_param';

/** 30 minuti: il doppio del TTL dell'invito, per la ragione spiegata sopra. */
const STASH_TTL_MS = 30 * 60 * 1000;

/**
 * 🔴 SCHEMA DEL PAYLOAD — `<tipo>_<resto>`, e questo e' L'UNICO punto in cui si
 * decide. Cambiarlo qui cambia tutto, per costruzione.
 *
 * ⚠️ IN ATTESA DI RATIFICA (or52 «deeplink-orc», proposta inviata il 06/09).
 * Questo fix e' il PRIMO consumatore non-`auth_` di `start_param` in tutta la
 * TMA — le due sheet di invito dicono ancora «No deep-link / startapp
 * plumbing» — quindi la forma scelta qui diventa la forma di tutti i deep link
 * futuri (schede torneo, news, eventi), che sono di or52 e non miei.
 *
 * Perche' il TIPO viene prima del gioco (`inv_bg_` e non `bg_`): il primo
 * segmento e' l'unica cosa che il dispatcher deve leggere. Mettendo il gioco in
 * testa, il registro dei tipi diventerebbe un registro dei GIOCHI, e una scheda
 * torneo o una news non ci starebbero dentro.
 *
 * Charset: Telegram ammette `[A-Za-z0-9_-]` in `startapp` (max 64). `inv_bg_` +
 * 10 caratteri di codice = 17: nessuna codifica, come per `auth_`.
 */
const INVITE_PREFIX = 'inv_bg_';

/**
 * Stesso alfabeto che `AcceptInviteSheet.normaliseCode` gia' accetta: `A-Z2-9`,
 * 10 caratteri. Volutamente NON piu' stretto del vicino, anche se il server
 * genera da un alfabeto che esclude pure I e O: un codice che l'utente puo'
 * digitare a mano e uno che arriva da un link devono essere validi insieme,
 * altrimenti si creano due nozioni di «codice valido» che divergono in silenzio.
 */
const CODE_RE = /^[A-Z2-9]{10}$/;

/**
 * ═══ `sfida_<challengeId>` — IL SECONDO TIPO (T2-5, lotto B3b-1) ═══
 * Chi riceve una sfida di piattaforma la trova anche su Telegram, col link `t.me/<bot>?startapp=sfida_<id>`: la consegna e'
 * di QBot/qourier, fuori dalla TMA; qui c'e' solo la parte che LEGGE il link. Grammatica DECISA da tma-orcr (proprietaria
 * di questo file, 29/9 11:33:47Z): `sfida_` + un id che il motore conia come `sfd-` + 8 esadecimali MINUSCOLI
 * (`persistenza/convenzioni.js:334-341`, `persistenza/sfida.model.js:33` di qTournaments @ qlash-limulo `5ffbb09` [M, riletto
 * il 29/9 17:34Z]; e ogni notifica di sfida porta
 * `challengeId` in quella forma [grado 3, kb#310, @gionko]).
 *
 * ⛔ Il riconoscimento e' ESATTO, con una regex CHIUSA: qualunque altra stringa che comincia con `sfida_` e' `null`, non
 * un tentativo. ⛔ E NIENTE `toUpperCase` sull'id: il ramo dell'invito alza il codice perche' il suo alfabeto e' maiuscolo,
 * mentre gli id `sfd-` sono minuscoli — alzarli li romperebbe, e accettare le maiuscole allargherebbe il riconoscimento a
 * stringhe che il motore non produce.
 * ⚠️ L'id che esce di qui e' un INPUT NON FIDATO: non si usa mai per una GET per id (`/v1/challenges/<id>`), si confronta
 * soltanto con la lista che l'utente ha gia' (`hooks/useEvidenzaSfida.ts`).
 */
const SFIDA_PREFIX = 'sfida_';
const SFIDA_RE = /^sfida_(sfd-[0-9a-f]{8})$/;

/**
 * ═══ `inc_<tournamentId>` — IL TERZO TIPO («partita pronta», I-356, ADR-0194) ═══
 * QBot manda un DM «partita pronta» con un bottone URL `https://t.me/<bot>?startapp=inc_<tournamentId>`: aprendolo si arriva
 * alla scheda del MIO incontro aperto in quel torneo. Forma DECISA da tma-orcb, sì di qbot-giochi-orcb (04/10, 16:04Z).
 *
 * 📌 Il carico e' il `tournamentId` di business e NON il `matchId`: il tid e' `[a-z0-9]{1,8}-[0-9a-f]{8}`
 * (`persistenza/tournament.model.ts:327`, `convenzioni.ts:424-451` di qTournaments @ `098e29d`; `sng-…` e `coda-…` da
 * `core/code.ts:1315`), quindi `inc_` + tid sta in 21 caratteri, dentro i 64 di `startapp`. Il matchId
 * (`domain/pairing.ts:62`: `<tid>/<step>/<lane>/r<n>/<pty>+<pty>`, ~54 caratteri con `/`, `+`, `:`) non entra nel link e non si
 * cerca li': l'incontro lo trova la schermata d'atterraggio nei dati dell'utente (`routes/IncontroLanding.tsx`).
 *
 * ⛔ Riconoscimento ESATTO con regex CHIUSA, come `sfida_`: qualunque altra stringa che comincia con `inc_` e' `null` — compreso
 * `inc_` + un matchId vero (ha `/`, `+`, `:`). ⛔ NIENTE `toUpperCase`: il tid e' minuscolo, e accettare le maiuscole
 * allargherebbe il riconoscimento a stringhe che il motore non produce.
 * ⚠️ Il tid che esce di qui e' un INPUT NON FIDATO: decide solo SE chiedere gli incontri (e' fra i miei tornei?), mai quale incontro aprire.
 */
const INCONTRO_PREFIX = 'inc_';
const INCONTRO_RE = /^inc_([a-z0-9]{1,8}-[0-9a-f]{8})$/;

/**
 * ═══ `guarda_bg_<uuid>` — IL QUARTO TIPO («Guarda» della DM «sta giocando», contratto di fronte QSocials r38) ═══
 * QBot manda la DM `segui_live` («un amico sta giocando») con un bottone URL `https://t.me/<bot>?startapp=guarda_bg_<matchId>`:
 * aprendolo si arriva alla visione in sola lettura `backgammon/live/<matchId>`. Il primo segmento resta il TIPO (`guarda`), il gioco
 * (`bg`) e' parte del carico — la regola di forma di `startParamRoutes.ts` — e il `matchId` e' l'UUID di QGammon (lo stesso che
 * `liveMatch.matchId` porta nella riga dell'amico). Regex CHIUSA, concordata con `qbot-stg-orcr-2-seguilive` il 07/10 (10:56Z):
 * 36 + 10 = 46 caratteri, dentro i 64 di `startapp`.
 *
 * ⛔ Riconoscimento ESATTO, come `sfida_` e `inc_`: qualunque altra stringa che comincia con `guarda_` e' `null` — compreso
 * `guarda_<uuid>` NUDO (senza il gioco: un gioco nuovo e' un tipo di carico nuovo, e si conia quando ha un consumatore), un UUID
 * troncato o in maiuscole. ⛔ NIENTE `toUpperCase`/`toLowerCase`: un UUID di QGammon e' minuscolo, e accettare le maiuscole
 * allargherebbe il riconoscimento a stringhe che il gameserver non produce.
 * ⚠️ L'id che esce di qui e' un INPUT NON FIDATO: decide solo DOVE navigare (la visione lo chiede al gameserver, e una partita non
 * viva da' la sua schermata), mai che cosa mostrare.
 */
const GUARDA_PREFIX = 'guarda_';
const GUARDA_RE = /^guarda_bg_([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/;

/**
 * ═══ `prova_spider[_pesante]` — IL QUINTO TIPO (LA PROVA D3 DELLO SPIDER, contratto «Solitari» P4, L-3812 (b), cantiere qsolitario-orcr-49-spider-link) ═══
 * ⛔ SI TOGLIE nella PR del motore dello Spider, insieme alla rotta `/solitario/spider-prova` (regex, `case 'provaSpider'` di `routes/startParamRoutes.ts`,
 * `lib/solitario/rottaSpiderProva.ts`, il campo `rottaSpiderProva`, e il parametro `opzioni` di `stashPendingStartParam` con la sua riga di filtro; in `main.tsx` il secondo argomento): non e` un tipo di atterraggio, e` il modo in cui Luca arriva alla tavola statica DENTRO Telegram.
 * Due parole FISSE, senza parametri (niente id): `prova_spider` e` la smazzata iniziale, `prova_spider_pesante` il caso pesante (condizioni di tma-orcr, 28/10 21:26Z e 21:28Z).
 * ⛔ Riconoscimento ESATTO con regex CHIUSA: qualunque altra stringa che comincia con `prova_spider` e` `null` (`prova_spiderx`, `prova_spider_`, `prova_spider_pesante_1`),
 * e NIENTE `toUpperCase`: `PROVA_SPIDER` non e` una chiave. La chiave resta come testo INERTE nell'entry di prod (il parser non conosce il flag): senza la rotta della build
 * (`rottaSpiderProva`) e senza il ruolo `beta` non salta, e resta la Hub (v. `routes/startParamRoutes.ts`).
 */
const PROVA_SPIDER_PREFIX = 'prova_spider';
const PROVA_SPIDER_RE = /^prova_spider(_pesante)?$/;

/**
 * Il payload di lancio riconosciuto: un'UNIONE DISCRIMINATA su `kind`. Il nome resta quello storico (`InvitePayload`),
 * perche' e' il tipo che il dispatcher e lo stash gia' scambiano; da B3b-1 i tipi sono due, con `inc_` tre.
 */
export type InvitePayload =
  | {
      kind: 'invite';
      /** Oggi solo QGammon. Il campo esiste perche' il prefisso lo distingue gia'. */
      game: 'qgammon';
      code: string;
    }
  | {
      kind: 'sfida';
      /** `sfd-` + 8 esadecimali minuscoli, cosi' come e' nel payload (nessuna normalizzazione). */
      challengeId: string;
    }
  | {
      kind: 'incontro';
      /** Il `tournamentId` di business, cosi' come e' nel payload (nessuna normalizzazione). INPUT NON FIDATO. */
      tournamentId: string;
    }
  | {
      kind: 'guarda';
      /** Oggi solo QGammon (`guarda_bg_`). */
      game: 'backgammon';
      /** L'UUID della partita di QGammon, cosi' com'e' nel payload (nessuna normalizzazione). INPUT NON FIDATO. */
      matchId: string;
    }
  | {
      /** La prova D3 dello Spider (si toglie nella PR del motore dello Spider). */
      kind: 'provaSpider';
      /** `prova_spider` ⇒ la smazzata iniziale; `prova_spider_pesante` ⇒ il caso pesante. */
      stato: 'iniziale' | 'pesante';
    };

interface StashedEntry {
  raw: string;
  savedAt: number;
}

/**
 * Riconosce un payload di lancio. Ritorna `null` per tutto cio' che non e' un
 * invito, una sfida, un incontro o una visione — compreso `auth_…`, che appartiene al bridge e NON va toccato qui.
 */
export function parseStartParam(raw: string | null | undefined): InvitePayload | null {
  if (raw && raw.startsWith(SFIDA_PREFIX)) {
    const m = SFIDA_RE.exec(raw);
    return m ? { kind: 'sfida', challengeId: m[1] } : null;
  }
  if (raw && raw.startsWith(INCONTRO_PREFIX)) {
    const m = INCONTRO_RE.exec(raw);
    return m ? { kind: 'incontro', tournamentId: m[1] } : null;
  }
  if (raw && raw.startsWith(GUARDA_PREFIX)) {
    const m = GUARDA_RE.exec(raw);
    return m ? { kind: 'guarda', game: 'backgammon', matchId: m[1] } : null;
  }
  if (raw && raw.startsWith(PROVA_SPIDER_PREFIX)) {
    const m = PROVA_SPIDER_RE.exec(raw);
    return m ? { kind: 'provaSpider', stato: m[1] ? 'pesante' : 'iniziale' } : null;
  }
  if (!raw || !raw.startsWith(INVITE_PREFIX)) return null;
  const code = raw.slice(INVITE_PREFIX.length).toUpperCase();
  if (!CODE_RE.test(code)) return null;
  return { kind: 'invite', game: 'qgammon', code };
}

/** Costruisce il payload da un codice invito (l'inverso di `parseStartParam`). */
export function inviteStartParam(code: string): string {
  return `${INVITE_PREFIX}${code.toUpperCase()}`;
}

/**
 * Il LINK da condividere per un invito. (L-404, forma ratificata da or52 `156031b`.)
 *
 * ═══ ⛔ `t.me/<bot>?startapp=…` — MAI `t.me/<bot>/app?startapp=…` ═══
 * Il percorso `/app` vuole una **Direct Link app** registrata con `/newapp` in
 * BotFather, che non e' mai stata creata. Quel link **apre la chat del bot invece
 * di rilanciare la mini app, e il `start_param` viene perso — SENZA errore.**
 * 🔑 E' il guasto peggiore possibile per un deep link: silenzioso, e
 * indistinguibile dal payload che non e' mai arrivato.
 * 📌 La cicatrice esiste gia' nel repo, sul ramo di auth: `AuthCallback.tsx:145-150`
 * usa la forma nuda e il commento spiega esattamente questo.
 * ⚠️ E `AGENTS.md` / `CLAUDE.md` documentavano la forma SBAGLIATA (corretto il
 * 2026-09-07, stessa PR): la riga del documento ha gia' portato una sessione
 * dentro il guasto. Se la trovi di nuovo con `/app`, e' il documento a essere
 * vecchio.
 *
 * ═══ IL BOT NON SI SCRIVE A MANO ═══
 * Arriva da `env.telegramBotUsername`, che e' **build-time**: la build di
 * produzione emette link di produzione, quella di staging link di staging, senza
 * che nessuno debba ricordarsene. ⇒ Il link lo costruisce l'APP, mai un umano —
 * un link scritto a mano e' un link dell'ambiente sbagliato appena qualcuno lo
 * copia. Questa funzione prende il bot come PARAMETRO (e non legge `env`) solo
 * perche' il modulo deve restare esercitabile dai cancelli con il solo Node.
 */
export function inviteShareLink(botUsername: string, code: string): string {
  // `encodeURIComponent` e' un no-op sull'alfabeto reale (`A-Z2-9`): sta qui per
  // un chiamante sbagliato, non per i codici veri. Un codice malformato produce
  // cosi' un payload che non parsa — che e' l'esito giusto, non un guasto.
  return `https://t.me/${botUsername}?startapp=${encodeURIComponent(inviteStartParam(code))}`;
}

/**
 * Mette da parte il payload, se ne e' uno. Va chiamata AL BOOTSTRAP, prima di
 * qualunque render e quindi prima che l'utente possa premere «Sign in»: e' quel
 * PRIMA a essere la correzione, non il salvataggio in se'.
 *
 * Ritorna cio' che ha salvato (o `null`), cosi' il chiamante puo' asserirlo.
 */
export function stashPendingStartParam(
  raw: string | null | undefined,
  opzioni?: { rottaSpiderProva: string | undefined },
): InvitePayload | null {
  const parsed = parseStartParam(raw);
  if (!parsed) return null;
  // ⛔ SI TOGLIE nella PR del motore dello Spider. Con `opzioni` (la passa il bootstrap) la chiave della prova, in una build SENZA la rotta, NON si mette da parte: lo stash e` UNA entry e sovrascrive, e un invito GIA in attesa andrebbe perso. Senza `opzioni`: come sempre.
  if (opzioni && parsed.kind === 'provaSpider' && !opzioni.rottaSpiderProva) return null;
  try {
    const entry: StashedEntry = { raw: raw as string, savedAt: Date.now() };
    localStorage.setItem(PENDING_KEY, JSON.stringify(entry));
  } catch {
    // localStorage non disponibile (private mode, storage bloccato): il deep
    // link degrada al comportamento di prima, non rompe il lancio.
    return null;
  }
  return parsed;
}

/** Legge lo stash senza consumarlo. `null` se assente, scaduto o illeggibile. */
export function peekPendingStartParam(): InvitePayload | null {
  let rawEntry: string | null = null;
  try {
    rawEntry = localStorage.getItem(PENDING_KEY);
  } catch {
    return null;
  }
  if (!rawEntry) return null;
  let entry: StashedEntry;
  try {
    entry = JSON.parse(rawEntry) as StashedEntry;
  } catch {
    clearPendingStartParam();
    return null;
  }
  if (!entry || typeof entry.savedAt !== 'number' || Date.now() - entry.savedAt > STASH_TTL_MS) {
    clearPendingStartParam();
    return null;
  }
  return parseStartParam(entry.raw);
}

/** Legge lo stash E lo cancella. Un payload si consuma una volta sola. */
export function consumePendingStartParam(): InvitePayload | null {
  const parsed = peekPendingStartParam();
  clearPendingStartParam();
  return parsed;
}

export function clearPendingStartParam(): void {
  try {
    localStorage.removeItem(PENDING_KEY);
  } catch {
    /* niente da fare: lo stash scade comunque da solo */
  }
}
